export default {
    title: "Digital Demo Studio",
    support: "Support"
}